import keyMirror from 'keymirror'

export default keyMirror({
  RENDER_TEAMS: null,
  ADD_TEAM: null,
  UPDATE_TEAM: null,
  UPDATE_TEAMS: null,
  CHOOSE_TEAM: null,
  UPDATE_USER: null,
  UPDATE_USER_NAME: null,
  FORCE_RELOAD: null,
})
